import { render, staticRenderFns } from "./Chemical.vue?vue&type=template&id=563fc57a&scoped=true"
import script from "./Chemical.vue?vue&type=script&lang=js"
export * from "./Chemical.vue?vue&type=script&lang=js"
import style0 from "./Chemical.vue?vue&type=style&index=0&id=563fc57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fc57a",
  null
  
)

export default component.exports